export default __webpack_public_path__ + "static/customised-solutions-2c0cac727d29ba318de7db7bac0319d3.webp";